import React, { useState } from 'react';
import Navigation from '../components/Navigation';
import Sidebar from '../components/Sidebar';
import { Spinner } from 'react-bootstrap';
import Cookies from 'js-cookie';
import base_url from '../config/Config';
import PageLoader from '../components/PageLoader';

const LoanDeactivate = () => {
    const [loanId, setLoanId] = useState('');
    const [pageLoading, setPageLoading] = useState(false);
    const [loading, setLoading] = useState(false);

    const token = Cookies.get('authToken');

    const handleDelete = async () => {
        if (!loanId.trim()) {
            alert('⚠️ Please enter a valid Loan ID');
            return;
        }

        if (!token) {
            alert('❌ User not authenticated. Please login again.');
            return;
        }

        const confirmDelete = window.confirm(
            `Are you sure you want to deactivate repayment for Loan ID: ${loanId}?`
        );
        if (!confirmDelete) return;

        setLoading(true);
        try {
            const response = await fetch(`${base_url}/api/repayment/delete?loanId=${loanId}`, {
                method: 'DELETE',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Accept': 'application/json',
                },
            });

            const responseText = await response.text();
            if (response.ok) {
                alert(`✅ ${responseText || 'Loan deactivated successfully!'}`);
                setLoanId('');
            } else {
                alert(`❌ Failed to deactivate loan: ${responseText || response.statusText}`);
            }
        } catch (error) {
            console.error('Error while deactivating loan:', error);
            alert('❌ Something went wrong while deactivating the loan. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <div className="overviewsaa">
                <h4>Deactivate Loan Repayment</h4>
            </div>

            <div className="navigationss mb-5">
                <Navigation />
            </div>

            <div className="container-fluid">
                <div className="row">
                    {/* Sidebar */}
                    <div className="col-lg-2 col-md-2 sidebarnavigartion">
                        <div className="lmssidebar">
                            <Sidebar />
                        </div>
                    </div>

                    {/* Main content */}
                    <div className="col-lg-10 col-md-10">
                        <div className="dashboardlms  text-center">
                            <div className="row justify-content-center">
                                <div className="col-md-4">
                                    <div className="">
                                        <label><strong>Loan ID</strong></label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Enter Loan ID"
                                            value={loanId}
                                            onChange={(e) => setLoanId(e.target.value)}
                                            disabled={loading}
                                        />
                                    </div>

                                    <button
                                        className="btn btn-danger mt-3 w-100"
                                        onClick={handleDelete}
                                        disabled={loading}
                                    >
                                        {loading ? (
                                            <>
                                                <Spinner animation="border" size="sm" /> Deactivating...
                                            </>
                                        ) : (
                                            'Deactivate Loan'
                                        )}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default LoanDeactivate;
